<div class="hidden md:block">
    <app-detail-page-header
        backLabel="Back to Reports"
        backLink="/assessments"
        title="Report Templates"
        [primaryCta]="headerPrimaryCta"
        [mobileBorderless]="true"
        (primaryCtaClick)="createNewAssessmentForm()">
        <div subnav class="w-full flex justify-content-start">
            <app-nav-tabs
                [navTabs]="navTabs"
                [currentTabType]="activeTab"></app-nav-tabs>
        </div>
    </app-detail-page-header>
</div>

<h1 class="mobile-title block md:hidden">Report Templates</h1>

<app-template-list></app-template-list>
